exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-container[data-v-3ad6c4e9]{max-width:1200px;margin:0 auto}.card-header[data-v-3ad6c4e9]{margin-bottom:20px}.avatar-uploader .el-upload[data-v-3ad6c4e9]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden;transition:all .3s}.avatar-uploader .el-upload[data-v-3ad6c4e9]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-3ad6c4e9]{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center}.avatar[data-v-3ad6c4e9]{width:178px;height:178px;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ad6c4e9","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Carousel.vue
// module id = eLk0
// module chunks = 1